module.exports = __webpack_public_path__ + "media/sns/yahoo_japan_icon_w_64-8a8660a4.png";